// NPM Imports
import { convertToRaw } from "draft-js";
import { Toastr } from "@revvsales/components";

// Components Imports
import BaseCommand from "./baseCommand";

// Actions Imports

// services import
import {
  createClauseOptions,
  updateTemplateComponentService,
  updateClauseOptionsService,
} from "../actions/DocumentTemplateActions/templateService";

// Internal Imports
import { TEMPLATE } from "../constants";

const { CLAUSES_OPTIONS } = TEMPLATE;

class ClauseOptionCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  execute() {
    const {
      id,
      type,
      name,
      description,
      clauses,
      defaultValue,
    } = this.componentData;
    this.command({ id, type, name, description, clauses, defaultValue });
  }

  command(clause) {
    const { id, section, fields, fieldsUsed } = this.componentData;
    const { type, clauses, defaultValue } = clause;
    let clauseId = id;

    if (this.restoreClauseOptionDetails && this.restoreClauseOptionDetails.id) {
      clauseId = this.restoreClauseOptionDetails.id;
      clause = this.restoreClauseOptionDetails;
      this.restoreClauseOptionDetails = null;
    }

    if (type === CLAUSES_OPTIONS.FREE_TEXT) {
      if (defaultValue && clauses.length > 0)
        clause.defaultValue = JSON.stringify(convertToRaw(clauses[0].data));
      clause.clauses = [];
    }

    const saveClauseOptions = clauseId
      ? updateClauseOptionsService
      : createClauseOptions;

    saveClauseOptions(clause)
      .then(response => {
        // update section clause with clause id and default value
        const {
          meta: { default: defaultOption },
        } = response;
        const sectionWithClause = {
          ...section,
          label: response.label || section.label,
          clauseOptions: { id: response.id, value: defaultOption || null },
        };

        const fieldIndex = fields.findIndex(field => field.id === clauseId);

        // Add WorkFlow ID, if the clause have one
        const workFlowId = fieldsUsed[clauseId] && fieldsUsed[clauseId].wf_id;
        if (workFlowId) {
          response.wf_id = workFlowId;
        }

        this.componentData.addDynamicFieldinListAsync(response, () =>
          updateTemplateComponentService(sectionWithClause).then(() => {
            this.componentData.updateClauseOptionsAndSection(
              response,
              sectionWithClause,
            );
            this.componentData.updateDocumentComponentAction(sectionWithClause);
            this.componentData.toggleDynamicFieldView("LIST");
            if (this.tempClasue) {
              this.componentData.id = null;
              this.componentData.clause = {
                ...this.componentData.clause,
                id: null,
              };
            }
            if (!id) {
              this.tempClasue = {
                ...clause,
                id: response.id,
              };
            }

            Toastr.showToastr({
              type: "success",
              message: `Clause ${
                fieldIndex > -1 ? "updated" : "added"
              } successfully`,
              timeout: 3000,
            });
          }),
        );
      })
      .catch(error => {
        const { status } = error;
        let message;
        if (status === 409) {
          message = `Couldn't save clause options. Error: Clause name should be unique.`;
        } else {
          message = `Couldn't save clause options.`;
        }
        Toastr.showToastr({
          type: "failure",
          message: `${message}`,
          timeout: 3000,
        });
      });
  }

  undo() {
    const { id, oldClauseInfo, section, updateComponent } = this.componentData;
    // Scroll section into view when do Undo/Redo
    if (section) {
      this.scrollIntoView(section.id);
    }
    // ------------- Update case -------------
    if (id) {
      this.command({ id, ...oldClauseInfo });
      this.redoable = true;
    }
    // ------------- Delete case -------------
    else {
      const updatedSection = {
        ...section,
        clauseOptions: null,
        form_field: [],
      };
      updateComponent(
        updatedSection,
        undefined,
        false,
        section,
        undefined,
        false,
      );
      this.redoable = true;
      if (this.tempClasue) {
        this.componentData.id = this.tempClasue.id;
        this.componentData.clause = {
          ...this.componentData.tempClasue,
          id: this.tempClasue.id,
        };
      }
    }
  }
}

export default ClauseOptionCommand;



// WEBPACK FOOTER //
// ./src/commands/clauseOptionCommand.js